import { setTag, setTags, setUser } from '@repo/monitoring';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getImpersonateId, getUsername } from 'store/user';
import useGetKitIdParam from './useGetKitIdParam';

const useMonitoringIdentity = () => {
  const username = useSelector(getUsername);
  const impersonateId = useSelector(getImpersonateId);
  const kitId = useGetKitIdParam();

  useEffect(() => {
    setUser(username ? { id: username } : null);
    setTags({
      main_account_id: impersonateId ?? username,
      impersonated: impersonateId ? true : undefined,
    });
  }, [username, impersonateId]);

  useEffect(() => {
    setTag('kit_id', kitId);
  }, [kitId]);
};

export default useMonitoringIdentity;
